import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import ComparisonTable from "../../../components/ComparisonTable/ComparisonTable";

export default function PanamaJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="Panama Jurisdiction"
                subtitle="Offshore Licensing, Banking & Company Formation in Panama"
                description="Panama is one of the most established offshore financial centers worldwide. Known for its robust banking sector, territorial tax system, and strong corporate services, it offers a cost-efficient alternative to EU jurisdictions like Malta or Cyprus. Panama is especially popular for banking, funds, insurance, and trusts, while iGaming operators often prefer Curacao or Isle of Man for broader recognition."
                badges={[
                    "Global Banking Hub",
                    "Funds & Insurance Expertise",
                    "Crypto-Friendly",
                    "Territorial Taxation"
                ]}
                buttonText="Request a Panama Licensing Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/jurisdictions/panama.jpg')}
                imageAlt="Panama Offshore Jurisdiction"
            />

            <section className='section'>
                <div className="container">

                    <h1 className='section-title'>
                        Main Licenses Available in Panama
                    </h1>
                    <WhySection
                        title='Banking License (General & International)'
                        subtitle='Regulated by the Superintendence of Banks of Panama (SBP).'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "General Banking License",
                                                text: "Operate locally and internationally. Accept deposits, issue loans, conduct full banking activities. Capital Requirement: USD 10M minimum."
                                            },
                                            {
                                                title: "International Banking License (Offshore Bank)",
                                                text: "Operate banking activities outside Panama only. Favored by offshore banking groups. Capital Requirement: USD 3M minimum."
                                            }
                                        ]
                                }
                            ]
                        }
                        end='Panama remains a top-tier banking hub in Latin America.'
                    />

                    <InfoBlocks
                        title="FinTech & Payment Services"
                        subtitle='Unlike EU-style EMI/PSP frameworks, Panama offers flexible structures:'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            { text: "Money Service Business (MSB) / Remittance companies (Ministry of Commerce)." },
                                            { text: "FinTech Platforms under corporate law, with Central Bank registration." },
                                        ]
                                }
                            ]
                        }
                        end='Lower recognition than Malta or Cyprus EMI but faster and cost-efficient.'
                    />

                    <LocationTimeline
                        title="Crypto & Blockchain Registration"
                        subtitle='Panama passed Law No. 697 (2022) regulating digital assets.'
                        item={
                            [
                                { text: "Covers exchanges, wallet providers, custodians, token issuance" },
                                { text: "Registered under the ISR-SNF (Intendencia de Supervisión y Regulación de Sujetos No Financieros)" },
                                { text: "No fixed capital requirement, AML/KYC rules apply" }
                            ]
                        }
                        end='Considered a progressive, pro-crypto jurisdiction in Latin America.'
                    />

                    <ServiceCards
                        title='Insurance & Reinsurance'
                        subtitle='Regulated by the Superintendence of Insurance & Reinsurance.'
                        services={
                            [
                                { text: "Life, non-life, and captive insurance companies" },
                                { text: "Reinsurance companies for regional/global coverage" },
                                { text: "Capital Requirement: USD 5M–10M+" }
                            ]
                        }
                        end='Regional strength, especially for reinsurance operations.'
                    />

                    <FeatureCards
                        title='Funds & Asset Management'
                        subtitle='Regulated by the Superintendence of Securities Market (SMV).'
                        features={
                            [
                                { text: "Investment Fund License – open/closed-end funds" },
                                { text: "Investment Advisor License – portfolio management" },
                                { text: "Broker-Dealer License – securities trading" },
                                { text: "Capital Requirement: USD 150k–300k" }
                            ]
                        }
                        end='Favored for private equity, hedge funds, and family offices in LatAm.'
                    />

                    <FeatureCards
                        title='Trust Company License'
                        subtitle='Regulated by the Superintendence of Banks of Panama.'
                        features={
                            [
                                { text: "Provides fiduciary, estate planning, and corporate trust management" },
                                { text: "Capital Requirement: USD 1M minimum" },
                                { text: "Strong trust law tradition, widely used by HNWIs" }
                            ]
                        }
                        end='Favored for private equity, hedge funds, and family offices in LatAm.'
                    />

                    <FeatureCards
                        title='Shipping & Maritime Licenses'
                        subtitle='Panama runs the largest shipping registry in the world.'
                        features={
                            [
                                { text: "Licensing for shipping companies, ship mortgages, and maritime services" },
                                { text: "Globally recognized" }
                            ]
                        }
                        end='Favored for private equity, hedge funds, and family offices in LatAm.'
                    />

                    <FeatureCards
                        title='Gaming Licenses (Limited)'
                        subtitle='Regulated by the Gaming Control Board (JCJ).'
                        features={
                            [
                                { text: "Covers land-based casinos and sportsbooks" },
                                { text: "Online gambling allowed but less recognized than Curacao or Malta" },
                                { text: "Mainly regional acceptance" }
                            ]
                        }
                    />

                    <ComparisonTable
                        title="Panama License Landscape"
                        columns={columns}
                        data={data}
                    />

                    <DetailsSection
                        title='Why Choose Panama?'
                        items={
                            [
                                { text: "Banking & Finance Hub for LatAm" },
                                { text: "Flexible regulations compared to EU Tier-1" },
                                { text: "Territorial tax system — foreign-sourced income not taxed" },
                                { text: "Crypto-friendly — progressive legal framework" },
                                { text: "Investor protection — strong trust and fund laws" }
                            ]

                        }
                    />

                    <FeatureCards
                        title='Best Uses'
                        features={
                            [
                                { text: "Strong for banking, funds, insurance, trusts, and crypto" },
                                { text: "Less suitable for iGaming and EMI (Malta, Cyprus, Curacao preferred)" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch a regulated crypto business in Latin America?"
                        description="Panama offers crypto licensing under Law 697, with low barriers, tax advantages, and global flexibility."
                        buttonText="Book a Panama Crypto License Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [

];


const testimonialsData =
    [

    ]
;


const columns = [
    "Sector",
    "License Type",
    "Capital Requirement",
    "Recognition"
];

const data = [
    {
        Sector: "Banking",
        "License Type": "General / International Banking License",
        "Capital Requirement": "$3M–$10M+",
        Recognition: "Global",
    },
    {
        Sector: "FinTech / Payments",
        "License Type": "MSB / Remittance Registration",
        "Capital Requirement": "Flexible",
        Recognition: "Regional",
    },
    {
        Sector: "Crypto",
        "License Type": "Digital Asset Registration (Law 697, 2022)",
        "Capital Requirement": "None fixed",
        Recognition: "Growing",
    },
    {
        Sector: "Insurance",
        "License Type": "Insurance / Reinsurance License",
        "Capital Requirement": "$5M–$10M+",
        Recognition: "Global",
    },
    {
        Sector: "Funds / Asset Mgmt",
        "License Type": "Fund, Broker-Dealer, Advisor License",
        "Capital Requirement": "$150k–$300k+",
        Recognition: "Global",
    },
    {
        Sector: "Trusts",
        "License Type": "Trust Company License",
        "Capital Requirement": "$1M+",
        Recognition: "Global",
    },
    {
        Sector: "Shipping",
        "License Type": "Maritime & Shipping Licenses",
        "Capital Requirement": "Varies",
        Recognition: "Global",
    },
    {
        Sector: "Gaming",
        "License Type": "Casino & Betting (JCJ)",
        "Capital Requirement": "Varies",
        Recognition: "Limited",
    },
];
